import LoginTest from '../components/LoginTest'

export default LoginTest;